/* Google Analytics 4 (gtag.js) — funil e-commerce da loja/portal MY. */
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export function initGA() {
  if (!GA_ID || window.__ihtpGaInit) return;
  window.__ihtpGaInit = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function gaEvent(name, params = {}) {
  try { if (window.gtag) window.gtag("event", name, { ...params, send_to: GA_ID }); } catch (_e) { /* noop */ }
}

/** Lê o client_id do cookie `_ga` (formato GA1.1.XXXX.YYYY → "XXXX.YYYY"). */
export function getGaClientId() {
  try {
    const m = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.([^;]+)/);
    return m ? m[1] : "";
  } catch (_e) { return ""; }
}

const num = (v) => Number(v) || 0;
const money = (v) => Math.round(num(v) * 100) / 100;

/** Converte produtos+packs do carrinho para o formato items[] do GA4. */
export function cartToGaItems(produtos = [], packs = []) {
  return [
    ...produtos.map((p) => ({
      item_id: String(p.ID_Produto ?? ""),
      item_name: p.Descricao || "Produto",
      item_brand: "IHTP",
      price: money(p.preco ?? p.PrecoUnitario),
      quantity: num(p.Quantidade) || 1,
    })),
    ...packs.map((p) => ({
      item_id: `pack-${p.ID_Pack ?? ""}`,
      item_name: p.Descricao || "Pack",
      item_brand: "IHTP",
      price: money(p.preco ?? p.PrecoUnitario),
      quantity: num(p.Quantidade) || 1,
    })),
  ];
}

/**
 * Monta items[] GA4 a partir do carrinho actual (nome + preço já ajustado ao
 * perfil do cliente), usando as quantidades efetivamente adicionadas.
 * @param {object} cartResp resposta de `myApi.cartGet()` (`{obj:{produtos}}` ou `{produtos}`).
 * @param {Array<{id_produto:(number|string), quantidade:number}>} added
 */
export function gaItemsFromCart(cartResp, added = []) {
  const data = cartResp?.obj || cartResp || {};
  const produtos = data.produtos || [];
  const byId = new Map(produtos.map((p) => [String(p.ID_Produto), p]));
  return added.map(({ id_produto, quantidade }) => {
    const line = byId.get(String(id_produto));
    return {
      item_id: String(id_produto),
      item_name: line?.Descricao || "Produto",
      item_brand: "IHTP",
      price: money(line?.preco ?? line?.PrecoUnitario ?? 0),
      quantity: num(quantidade) || 1,
    };
  });
}

/** Evento e-commerce GA4 (add_to_cart, view_cart, begin_checkout, …). */
export function gaEcommerce(name, items, value, currency = "EUR", extra = {}) {
  gaEvent(name, { currency: currency || "EUR", value: money(value), items, ...extra });
}
